import apiHeader from '@/helpers/apiHeader';

const subMenuService = {
  list(page, params) {
    return apiHeader.get(`general-setting/sub-menu?page=${page}`, { params });
  },
  // get(id) {
  //   return apiHeader.get(`general-setting/sub-menus/${id}`);
  // },
  // updateStatus(code) {
  //   return apiHeader.get(`general-setting/sub-menus/${code}/update-status`);
  // },
};

export default subMenuService;
